module.exports = __webpack_public_path__ + "media/images/menu_izq/proveedor-71aa2a37632d6047d031bfda8ce012af.svg";